import { LocalDate } from "@js-joda/core";
import React from "react";
import { AddressComponents, PatientGender, PatientTaskInstanceId } from "../../../messages";
import { TaskDayTimeParams } from "../../../messages/PatientTasks";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { AppCard, AppCardContent, AppCardHeader, AppCardTitle } from "../../Generic/AppCard";
import { AppList } from "../../Generic/AppList";
import { IsDefined } from "../../Generic/IsDefined";
import PatientInformationAppListItem from "../../PatientInformationAppListItem";
import PatientScheduleListItem from "../../PatientScheduleListItem";
import AvailableTaskAddress from "./AvailableTaskAddress";
import AvailableTaskDurationMinutes from "./AvailableTaskDurationMinutes";
import AvailableTaskTimeFrame from "./AvailableTaskTimeFrame";
import LinkedPatientAppListItem from "../../LinkedPatientAppListItem";

interface Props {
  timeframe?: {
    dayTimeParams: TaskDayTimeParams;
    startDate: LocalDate;
    dueDate: LocalDate;
  };
  durationMinutes: number | null;
  patientAddress: string | null;
  patientAddressComponents: AddressComponents | null;
  patientAge: number | null;
  patientGender: PatientGender | null;
  patientName: string;
  linkedPatientName: string | null;
  linkedPatientTaskInstanceId: PatientTaskInstanceId | null;
  onClickLocation: () => void;
  onClickPatientSchedule?: () => void;
  onClickLinkedPatient: () => void;
}

const AvailableTaskDetails = (props: Props) => {
  return (
    <div className="AvailableTaskDetails">
      <AppCard>
        <AppCardHeader>
          <AppCardTitle>{translate(STRINGS.VISIT_DETAILS)}</AppCardTitle>
        </AppCardHeader>
        <AppCardContent>
          <AppList>
            {props.timeframe !== undefined && (
              <AvailableTaskTimeFrame
                dayTimeParams={props.timeframe.dayTimeParams}
                startDate={props.timeframe.startDate}
                dueDate={props.timeframe.dueDate}
              />
            )}

            <IsDefined value={props.durationMinutes}>
              {(durationMinutes) => (
                <AvailableTaskDurationMinutes durationMinutes={durationMinutes} />
              )}
            </IsDefined>

            <AvailableTaskAddress
              addressString={props.patientAddress}
              addressComponents={props.patientAddressComponents}
              addressInstructions={null}
              onClickLocation={props.onClickLocation}
            />

            <PatientInformationAppListItem
              patientAge={props.patientAge}
              patientGender={props.patientGender}
              patientName={props.patientName}
              hasAccessToPatient={false}
            />

            {props.linkedPatientName !== null && props.linkedPatientTaskInstanceId !== null && (
              <LinkedPatientAppListItem
                linkedPatientName={props.linkedPatientName}
                onClickOpen={props.onClickLinkedPatient}
              />
            )}

            {props.onClickPatientSchedule !== undefined && (
              <PatientScheduleListItem onClick={props.onClickPatientSchedule} />
            )}
          </AppList>
        </AppCardContent>
      </AppCard>
    </div>
  );
};

export default AvailableTaskDetails;
